import React, {useEffect, useRef, useState} from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import styled from 'styled-components';

interface StyledComponentProps {
    isToday:any
    isTodayOrPast:any
}

const CalendarWrapper = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius:8px 8px 0 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    h1{
        font-family: Europa-Bold;
        font-size: 20px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 20px;
    }
`;

const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
    .btns{
    
        display: flex;
    }
    button{
        cursor: pointer;
        border-radius: 50%;
        display: flex;
        padding: 10px;
        background: none;
        border: none;
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover{
            background: #333;
            svg{
                path{
                    fill: #fff;
                }
            }
        }
    }
    .next{
        margin-left: 6px;
        svg{
            transform: rotate(180deg);
        }
    }
`;

const CalendarTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
const CalendarTitle = styled.div`
  
`
const Day = styled.div`
  
`

const CalendarTh = styled.div`
  flex: 1;
  padding: 10px;
  text-align: center;
  color: #333;
    font-weight: 500;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
`;

const CalendarTd = styled.div<StyledComponentProps>`
    flex: 1;
    padding: 10px;
    text-align: center;
    transition: all 0.2s;
    border-radius: 10px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    //border: 1px solid #e1e1e1;
    opacity: ${(props) => (!props.isTodayOrPast ? '#fff' : 0.3)};
    pointer-events: ${(props) => (!props.isTodayOrPast ? 'all' : "none")};;
    border-radius: ${(props) => (props.isToday ? '50%' : '0')};
    &.today{
        background: #eee;
    }
    &.selected{
        background: rgba(51, 51, 51, 1);
        border-radius: 50%;
        color: #fff;
    }
    &.minDate{
        pointer-events: none;
        opacity: 0.3;
    }
`;

const CalendarInputWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const CalendarInput = styled.input`
  flex: 1;
  padding: 8px;
  margin-right: 10px;
`;

const CalendarButton = styled.button`
  background-color: #3498db;
  color: #ffffff;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const Calendar = (props) => {
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [inputDate, setInputDate] = useState('');
    const [height, setHeight] = useState(50)
    const sizeRef = useRef(null)
    const [selectedDate, setSelectedDate] = useState(null);

    useEffect(() => {
        if(sizeRef.current){
            setHeight(sizeRef.current.clientWidth)
        }
    }, [sizeRef.current]);
    const handleInputChange = (e) => {
        setInputDate(e.target.value);
    };

    const handleDateSubmit = () => {
        if (dayjs(inputDate).isValid()) {
            setCurrentDate(dayjs(inputDate));
        } else {
            alert('올바른 날짜 형식을 입력하세요.');
        }
    };

    // useEffect(() => {
    //     props.onClickPopupDate(dayjs(new Date()).format("YYYY-MM-DD"))
    // }, []);

    useEffect(() => {
        console.log("@select", selectedDate);
        setSelectedDate(dayjs(props.popupDate))
        setCurrentDate(dayjs(props.popupDate))

    }, [props.popupDate]);

    useEffect(() => {
        if (selectedDate?.isBefore(props?.minDate, 'day')) {
            const nextDay = dayjs(props?.minDate)?.clone()?.add(1, 'day'); // minDate 다음 날짜 계산
            setSelectedDate(nextDay); // 다음 날짜로 setSelectedDate 설정
            if(props.minDate){
                props.onClickPopupDate(nextDay.format("YYYY-MM-DD"))
            }
        }
    }, [props?.minDate]);

    console.log("@props",props);
    const renderCalendar = () => {
        const weekdays = Array.from({ length: 7 }, (_, i) => dayjs().startOf('week').add(i, 'day').format('ddd'));

        return (
            <CalendarWrapper
                className={"calendarWrapper"}
            >
                {/*<CalendarInputWrapper>*/}
                {/*    <CalendarInput type="text" value={inputDate} onChange={handleInputChange} placeholder="YYYY-MM-DD" />*/}
                {/*    <CalendarButton onClick={handleDateSubmit}>날짜 변경</CalendarButton>*/}
                {/*</CalendarInputWrapper>*/}
                <h1>
                    Select the date(s) you want to<br/>
                    assign specific hours
                </h1>
                <CalendarHeader>
                    <h2>{currentDate.format('MMMM YYYY')}</h2>
                    <div className="btns">
                        <button onClick={goToPreviousMonth}>
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M1.81089 5.00075L5.77929 1.22102C6.07357 0.941048 6.07357 0.488922 5.77929 0.209033C5.63933 0.0752656 5.44843 -2.38159e-07 5.24932 -2.29455e-07C5.05021 -2.20752e-07 4.85931 0.0752657 4.71936 0.209033L0.22099 4.494C-0.0736636 4.77372 -0.0736636 5.2262 0.22099 5.50591L4.71917 9.79097C4.85931 9.92473 5.05021 10 5.24932 10C5.44843 10 5.63933 9.92473 5.77948 9.79097C6.07357 9.5109 6.07338 9.05886 5.7791 8.77889L1.81089 5.00075Z"
                                      fill="#333333"/>
                            </svg>
                        </button>
                        <button onClick={goToNextMonth} className={"next"}>
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M1.81089 5.00075L5.77929 1.22102C6.07357 0.941048 6.07357 0.488922 5.77929 0.209033C5.63933 0.0752656 5.44843 -2.38159e-07 5.24932 -2.29455e-07C5.05021 -2.20752e-07 4.85931 0.0752657 4.71936 0.209033L0.22099 4.494C-0.0736636 4.77372 -0.0736636 5.2262 0.22099 5.50591L4.71917 9.79097C4.85931 9.92473 5.05021 10 5.24932 10C5.44843 10 5.63933 9.92473 5.77948 9.79097C6.07357 9.5109 6.07338 9.05886 5.7791 8.77889L1.81089 5.00075Z"
                                      fill="#333333"/>
                            </svg>

                        </button>
                    </div>

                </CalendarHeader>
                <CalendarTable>
                    <CalendarTitle style={{display: 'flex'}}>
                        {weekdays.map((day, index) => (
                            <CalendarTh key={index}>{day}</CalendarTh>
                        ))}
                    </CalendarTitle>
                    {generateCalendarMatrix().map((week, weekIndex) => (
                        <Day key={weekIndex} style={{display: 'flex'}}>
                            {week.map((day, dayIndex) => (
                                <CalendarTd
                                    ref={sizeRef}
                                    style={{
                                        height:height,
                                    }}
                                    onClick={()=>{
                                        if(!day) return;
                                        setSelectedDate(day)
                                        props.onClickPopupDate(day.format("YYYY-MM-DD"))
                                        console.log("@select",selectedDate);
                                    }}
                                    className={`${day && day.isSame(dayjs(), 'day') ? "today" : ""} ${selectedDate && selectedDate.isSame(day, 'day') ? "selected" : ""} ${props.minDate && day && day.isBefore(props.minDate, 'day') ? "minDate" : ""}`}
                                    isToday={day && day.isSame(dayjs(), 'day')}
                                    isTodayOrPast={day && day.isBefore(dayjs(), 'day')}
                                    key={dayIndex}>
                                    {day ? day.format('D') : ''}
                                </CalendarTd>
                            ))}
                        </Day>
                    ))}
                </CalendarTable>
            </CalendarWrapper>
        );
    };

    const generateCalendarMatrix = () => {
        const firstDayOfMonth = currentDate.startOf('month').startOf('week');
        const lastDayOfMonth = currentDate.endOf('month').endOf('week');

        const calendarMatrix = [];
        let currentDay = firstDayOfMonth.clone();

        while (currentDay.isBefore(lastDayOfMonth) || currentDay?.isSame(lastDayOfMonth, 'day')) {
            const week = [];
            for (let i = 0; i < 7; i++) {
                week.push(currentDay.clone());
                currentDay = currentDay.add(1, 'day');
            }
            calendarMatrix.push(week);
        }

        return calendarMatrix;
    };

    const goToPreviousMonth = () => {
        setCurrentDate(currentDate.subtract(1, 'month'));
    };

    const goToNextMonth = () => {
        setCurrentDate(currentDate.add(1, 'month'));
    };

    return (
        <Container className={"customCalendar"}>
            {renderCalendar()}
        </Container>
    );
};

const Container = styled.div`
   
`
export default Calendar
